//PrimeReact
import { Button } from "primereact/button"

//Styles
import assessStyles from "../../../../../styles/assessments/Assessment.module.css"

export default function QuestionOrderButtons({
  onEdit,
  onDelete,
  dndAttributes,
  dndListeners,
  disabled,
}) {
  return (
    <>
      <Button
        className={assessStyles.actionButton}
        type="button"
        tooltip={disabled ? "View" : "Edit"}
        tooltipOptions={{ position: "bottom" }}
        onClick={() => {
          onEdit()
        }}
      >
        <span className={`material-icons`}>
          {disabled ? "visibility" : "edit"}
        </span>
      </Button>
      {!disabled && (
        <>
          <Button
            className={assessStyles.actionButton}
            type="button"
            tooltip="Delete"
            tooltipOptions={{ position: "bottom" }}
            onClick={(event) => {
              onDelete(event)
            }}
            disabled={disabled}
          >
            <span className={`material-icons`}>{"delete"}</span>
          </Button>
          <Button
            className={assessStyles.actionButton}
            type="button"
            tooltip="Drag this element to order it in the list"
            tooltipOptions={{ position: "bottom" }}
            {...dndAttributes}
            {...dndListeners}
            disabled={disabled}
          >
            <span className={`material-icons`}>{"drag_indicator"}</span>
          </Button>
        </>
      )}
    </>
  )
}
